import type { RosterEnrollmentStatus } from "../types";
import { useLocale } from "../../../context/LanguageContext";

const STATUS_CONFIG: Record<
  RosterEnrollmentStatus,
  { labelKey: string; className: string }
> = {
  ACTIVE: {
    labelKey: "roster.statusActive",
    className: "bg-success/10 text-success",
  },
  PENDING: {
    labelKey: "roster.statusPending",
    className: "bg-warning/10 text-warning",
  },
  NOT_INVITED: {
    labelKey: "roster.statusNotInvited",
    className: "bg-muted text-muted-foreground",
  },
};

export function RosterRowStatusBadge({
  status,
}: {
  status: RosterEnrollmentStatus;
}) {
  const { t } = useLocale();
  const config = STATUS_CONFIG[status];
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${config.className}`}
    >
      {t(config.labelKey)}
    </span>
  );
}
